import React, { useEffect } from 'react';
import HeaderBackground from '@assets/images/ElitePrime_header.png';
import ProtoHeader from './ProtoHeader';
import { useMediaQuery, useTheme } from '@mui/material';
import { useMetadataStore } from '@stores/Metadata/Metadata';

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { configuracoes, fetchConfiguracoes } = useMetadataStore();

  useEffect(() => {
    fetchConfiguracoes();
  }, [fetchConfiguracoes]);

  const bgUri = configuracoes?.header_background_uri || HeaderBackground;
  const whatsapp = configuracoes?.whatsapp_empresa || '(15) 98137-0057';

  const positionParts = (
    configuracoes?.header_contact_info_position ?? '30,140'
  ).split(',');
  const overlayBottom = Number(positionParts[0]) || 30;
  const overlayRight = Number(positionParts[1]) || 140;

  return (
    <ProtoHeader
      backgroundUri={bgUri}
      whatsapp={whatsapp}
      overlayBottom={isMobile ? 20 : overlayBottom}
      overlayRight={isMobile ? 100 : overlayRight}
    />
  );
};

export default Header;
